import styled from "styled-components";

import { hexToRGB } from "./util";

// For Credential Name
export const Title = styled.h1`
	font-family: Roboto;
	font-weight: 700;
	font-size: 1.5rem;
	line-height: 1.8rem;
	color: ${(props) => hexToRGB(props.theme.fontColor1)};
	margin: 0;
	margin-bottom: 0.25rem;
`;

// For Recipient Name
export const AccentTitle = styled(Title)`
	color: ${(props) => props.theme.primaryColor};
	margin: 0;
	/* margin-bottom: 0.4rem; */
`;

// For detail sections Headings
export const SubTitle1 = styled.h2`
	font-family: Roboto;
	font-weight: 700;
	font-size: 1rem;
	line-height: 1.188rem;
	margin: 0;
	margin-bottom: 0.2rem;
	color: ${(props) => hexToRGB(props.theme.fontColor1, props.theme.fontColor1Opacity || 0.87)};
	text-transform: ${(props) => props.textTransform};
`;

// For detail section normal text
export const SubTitle2 = styled.h2`
	font-family: Roboto;
	font-weight: 400;
	font-size: 1rem;
	line-height: 1.188rem;
	margin: 0;
	color: ${(props) => hexToRGB(props.theme.fontColor2, props.theme.fontColor2Opacity || 0.54)};
	text-transform: ${(props) => props.textTransform};
`;

// For detail section org link
export const Link = styled.a`
	font-family: Roboto;
	font-weight: 400;
	font-size: 1rem;
	line-height: 1.188rem;
	margin: 0;
	color: ${(props) => props.theme.primaryColor};
`;

// For Print certificate button
export const ButtonTitle1 = styled.h2`
	font-family: Roboto;
	font-weight: 700;
	font-size: 1.1rem;
	line-height: 1.32rem;
	color: ${(props) => hexToRGB(props.theme.primaryColor, props.theme.primaryColorTransparency || 1)};
`;

// For verify and add to linkedin profile buttons
export const ButtonTitle1Filled = styled(ButtonTitle1)`
	color: #fff;
`;

// For
export const ButtonTitle2 = styled.h2`
	font-family: Roboto;
	font-weight: 700;
	font-size: 0.9rem;
	line-height: 1.03rem;
	color: ${(props) => hexToRGB(props.theme.fontColor2 || "#000", props.theme.fontColor2Opacity || 0.87)};
`;

export const ButtonTitle2Lighter = styled(ButtonTitle2)`
	color: ${(props) => hexToRGB(props.theme.fontColor2 || "#000", props.theme.fontColor2Opacity || 0.54)};
`;

export const ButtonTitle2Primary = styled(ButtonTitle2)`
	color: ${(props) => hexToRGB(props.theme.primaryColor, props.theme.primaryColorTransparency || 1)};
`;

// For Footer button
export const ButtonTitle2Filled = styled(ButtonTitle2)`
	color: #fff;
`;

// credential description, content/transcripts / , and sections
export const Content = styled.p`
	font-family: Roboto;
	font-weight: 500;
	margin: 0;
	font-size: 0.9rem;
	line-height: 1rem;
	color: ${(props) => hexToRGB(props.theme.fontColor2, props.theme.fontColor2Opacity || 0.87)};
`;

export const Resources = styled.p`
	font-family: Roboto;
	font-weight: 700;
	margin: 0;
	font-size: 0.9rem;
	line-height: 1rem;
	color: ${(props) => hexToRGB(props.theme.fontColor1, props.theme.fontColor1Opacity || 0.87)};
`;
export const Description = styled.span`
	font-family: Roboto;
	font-weight: 400;
	font-size: 0.9rem;
	line-height: 1rem;
	color: ${(props) => hexToRGB(props.theme.fontColor2, props.theme.fontColor2Opacity || 0.87)};
`;

export const TipText = styled.span`
	font-family: Roboto;
	font-weight: 400;
	font-size: 0.6rem;
	line-height: 0.8rem;
	color: ${(props) => hexToRGB(props.color, props.opacity || 0.87)};
`;

export const TypographyH4 = styled.h4`
	font-family: Roboto;
	font-size: 2.125rem;
	font-weight: 400;
	line-height: 1.235;
	letter-spacing: 0.00735em;
	margin: 0;
`

export const TypographyH5 = styled.h5`
	font-family: Roboto;
	font-size: 1.5rem;
	font-weight: 400;
	line-height: 1.334;
	letter-spacing: 0em;
	margin: 0;
`